<div class="navigation-container">
  <button (click)="transformMenu()" *ngIf="!showMenu" class="menu-icon" icon="pi pi-bars" id="menuBtn" pButton type="button"></button>
  <div *ngIf="showMenu" class="menu-content" id="menuContent">
    <div class="menu-button-section">
      <button #appAutoFocus (click)="transformMenu()" class="menu-icon" icon="pi pi-bars" pButton type="button"></button>
    </div>
    <div
      (click)="selectMenuItem(item.id)"
      *ngFor="let item of menuItems"
      class="menu-item"
      tabindex="0"
      [class.menu-item-active]="item.id === selectedItem">
      <i class="{{ item.icon }}"></i>
      <span class="menu-item-text">{{ 'app.navigation.' + item.label | translate }}</span>
    </div>
  </div>
</div>
